import { categories } from "@/mocks/manga";

export default function Category() {
  return (
    <section id="category" className="bg-secondary-100/60">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="text-center">
          <p className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-sm font-medium text-secondary-800">
            <i className="ri-grid-fill"></i>
            漫画分类
          </p>
          <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">按类型找你想看的</h2>
          <p className="mx-auto mt-2 max-w-2xl text-sm text-foreground-600 md:text-base">
            从古风奇幻到悬疑冒险，海量分类任你挑选，每一类都有周更连载持续上新。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((c) => (
            <article
              key={c.name}
              className="group flex items-center gap-4 rounded-xl bg-background-50 p-5 ring-1 ring-background-200/70 transition-colors hover:ring-primary-300"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                <i className={`${c.icon} text-2xl`}></i>
              </span>
              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="font-medium text-foreground-950">{c.name}</h3>
                  <span className="rounded-full bg-background-200 px-2 py-0.5 text-xs text-foreground-600">
                    {c.works} 部
                  </span>
                </div>
                <p className="mt-1 text-sm text-foreground-600">{c.desc}</p>
              </div>
              <a
                href="#ranking"
                aria-label={`前往${c.name}榜单`}
                className="ml-auto shrink-0 text-foreground-400 transition-colors group-hover:text-primary-600"
              >
                <i className="ri-arrow-right-s-line text-2xl"></i>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}